import { css } from 'styled-components';

const checkNumber = prop => typeof prop === 'number';
const format = defaultValue => prop => checkNumber(prop) ? `${prop}px` : `${defaultValue}px`;

const defaultGap = 0;
const formatGap = format(defaultGap);
// eslint-disable-next-line complexity
export const flexProps = props => css`
  ${props.jcc && 'justify-content: center'};
  ${props.jcsb && 'justify-content: space-between'};
  ${props.jcsa && 'justify-content: space-around'};
  ${props.jcse && 'justify-content: space-evenly'};
  ${props.jcfe && 'justify-content: flex-end'};
  ${props.jcfs && 'justify-content: flex-start'};
  ${props.aic && 'align-items: center'};
  ${props.aib && 'align-items: baseline'};
  ${props.aifs && 'align-items: flex-start'};
  ${props.fdr && 'flex-direction: row'};
  ${props.fdc && 'flex-direction: column'};
  ${props.ffrw && 'flex-flow: row wrap'};
  ${props.ffrn && 'flex-flow: row nowrap'};
  ${props.ffcw && 'flex-flow: column wrap'};
  ${props.ffcn && 'flex-flow: column nowrap'};
  ${props.flex && `flex: ${props.flex || 1}`};
  ${props.gap && `gap: ${formatGap(props.gap)}`};
  ${props.colGap && `column-gap: ${formatGap(props.colGap)}`};
  ${props.rowGap && `row-gap: ${formatGap(props.rowGap)}`};
`;

const defaultBorder = 1;
const formatBorder = format(defaultBorder);
export const borderProps = props => css`
  ${props.borderBottom &&
  `border-bottom: ${formatBorder(props.borderWidth)} solid ${props.borderColor ||
  props.theme.colors.border}`};
  ${props.borderTop &&
  `border-top: ${formatBorder(props.borderWidth)} solid ${props.borderColor ||
  props.theme.colors.border}`};
  ${props.borderLeft &&
  `border-left: ${formatBorder(props.borderWidth)} solid ${props.borderColor ||
  props.theme.colors.border}`};
  ${props.borderRight &&
  `border-right: ${formatBorder(props.borderWidth)} solid ${props.borderColor ||
  props.theme.colors.border}`};
`;

export const fontWeightProps = props => css`
  ${props.fontWeightLight && `font-weight: ${props.theme.fontWeight.light}`};
  ${props.fontWeightNormal && `font-weight: ${props.theme.fontWeight.normal}`};
  ${props.fontWeightBold && `font-weight: ${props.theme.fontWeight.bold}`};
  ${props.fontWeightBolder && `font-weight: ${props.theme.fontWeight.bolder}`};
`;

const defaultMargin = 5;
const formatMargin = format(defaultMargin);
export const marginProps = props => css`
  ${props.marginBottom && `margin-bottom: ${formatMargin(props.marginBottom)}`};
  ${props.marginTop && `margin-top: ${formatMargin(props.marginTop)}`};
  ${props.marginLeft && `margin-left: ${formatMargin(props.marginLeft)}`};
  ${props.marginRight && `margin-right: ${formatMargin(props.marginRight)}`};
  ${props.margin && `margin: ${formatMargin(props.margin)}`};
  ${props.marginVertical &&
  `
    margin-top: ${formatMargin(props.marginVertical)}
    margin-bottom: ${formatMargin(props.marginVertical)}
  `};
  ${props.marginHorizontal &&
  `
    margin-left: ${formatMargin(props.marginHorizontal)}
    margin-right: ${formatMargin(props.marginHorizontal)}
  `};
  ${props.marginLeftAuto && 'margin-left: auto;'};
`;

const defaultPadding = 5;
const formatPadding = format(defaultPadding);
export const paddingProps = props => css`
  ${props.paddingBottom && `padding-bottom: ${formatPadding(props.paddingBottom)}`};
  ${props.paddingTop && `padding-top: ${formatPadding(props.paddingTop)}`};
  ${props.paddingLeft && `padding-left: ${formatPadding(props.paddingLeft)}`};
  ${props.paddingRight && `padding-right: ${formatPadding(props.paddingRight)}`};
  ${props.padding && `padding: ${formatPadding(props.padding)}`};
  ${props.paddingVertical &&
  `
    padding-top: ${formatPadding(props.paddingVertical)}
    padding-bottom: ${formatPadding(props.paddingVertical)}
  `};
  ${props.paddingHorizontal &&
  `
    padding-left: ${formatPadding(props.paddingHorizontal)}
    padding-right: ${formatPadding(props.paddingHorizontal)}
  `};
`;

export const widthProps = props => css`
  ${props.width && `width: ${props.width}`};
  ${props.minWidth && `min-width: ${props.minWidth}`};
  ${props.maxWidth && `max-width: ${props.maxWidth}`};
`;

export const heightProps = props => css`
  ${props.height && `height: ${props.height}`};
  ${props.minHeight && `min-height: ${props.minHeight}`};
  ${props.maxHeight && `max-height: ${props.maxHeight}`};
`;

export const errorProps = props => css`
  ${props.hasError && 'outline: 0; box-shadow: none; border-color: #f04134!important;'};
  ${props.hasError && '&:hover {outline: 0;box-shadow: none; border-color: #f04134;}'};
  ${props.hasError && '&:focus {outline: 0;box-shadow: none; border-color: #f04134;}'};
`;
